var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMonitor = function SvgIconMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 19a2.5 2.5 0 0 0 2.5-2.5V6a2.5 2.5 0 0 0-2.5-2.5h-15A2.5 2.5 0 0 0 2 6v10.5A2.5 2.5 0 0 0 4.5 19zm.5-2.5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20.375a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconMonitor;